import { Box, Modal } from "@mui/material";
import { ReactNode } from "react";

interface IProps {
  isOpen: boolean;
  children: ReactNode;
}

export function ModalStatus({ isOpen, children }: IProps) {
  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "auto",
          width: "100%",
          maxWidth: 850,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "1rem",
          border: "none",
          outline: "none",
          padding: "24px",
        }}
      >
        {children}
      </Box>
    </Modal>
  );
}
